import React from 'react';
import { GlobalStyles } from '@mui/material';
import { Experimental_CssVarsProvider as CssVarsProvider, experimental_extendTheme as extendTheme, StyledEngineProvider, } from '@mui/material/styles';
import ddsTheme from './theme';
const ThemeProvider = ({ children, theme = ddsTheme, }) => {
    const cssVarTheme = extendTheme(Object.assign(Object.assign({}, theme), { cssVarPrefix: 'dds' }));
    return (React.createElement(CssVarsProvider, { theme: cssVarTheme },
        React.createElement(GlobalStyles, { styles: {
                ':root': {
                    '--dds-font-weight-light': theme.typography.fontWeightLight,
                    '--dds-font-weight-regular': theme.typography.fontWeightRegular,
                    '--dds-font-weight-medium': theme.typography.fontWeightMedium,
                    '--dds-font-weight-semibold': theme.typography.fontWeightSemibold,
                    '--dds-font-weight-bold': theme.typography.fontWeightBold,
                    fontFamily: 'Mulish, sans-serif',
                    fontWeight: 400,
                },
            } }),
        React.createElement(StyledEngineProvider, { injectFirst: true }, children)));
};
export default ThemeProvider;
